var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHpVideoActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#A3D7FF;}\r\n\t.st2{fill:#006EFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1024,
    height: 1024
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M902.8,209c-4.1-10.5-13.5-18.1-24.7-19.9c-242.6-38.8-489.7-38.8-732.3,0c-11.2,1.8-20.6,9.4-24.8,20 c-76.2,194.8-76.2,411.2,0,606c4.1,10.5,13.5,18.1,24.7,19.9c121.1,19.3,243.5,29,366.2,29c122.6,0,245.1-9.7,366.2-29.1 c11.2-1.8,20.6-9.4,24.7-20C979.1,620.1,979.1,403.7,902.8,209L902.8,209z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M679.9,539.8L416.4,690.3c-7.7,4.4-17.4,1.7-21.8-6c-1.4-2.4-2.1-5.2-2.1-7.9V347.6c0-8.8,7.2-16,16-16 c2.8,0,5.5,0.7,7.9,2.1l263.4,150.5C701.4,496.5,701.4,527.5,679.9,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M830.2,727.8l110.9,43.8c4.1,1.6,6.1,6.3,4.5,10.4c-0.8,2.1-2.4,3.7-4.5,4.5l-110.9,43.8l-43.8,110.9 c-1.6,4.1-6.3,6.1-10.4,4.5c-2.1-0.8-3.7-2.4-4.5-4.5l-43.8-110.9l-110.9-43.8c-4.1-1.6-6.1-6.3-4.5-10.4c0.8-2.1,2.4-3.7,4.5-4.5 l110.9-43.8l43.8-110.9c1.6-4.1,6.3-6.1,10.4-4.5c2.1,0.8,3.7,2.4,4.5,4.5L830.2,727.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M228.2,155.8l72.9,28.8c4.1,1.6,6.1,6.3,4.5,10.4c-0.8,2.1-2.4,3.7-4.5,4.5l-72.9,28.8l-28.8,72.9 c-1.6,4.1-6.3,6.1-10.4,4.5c-2.1-0.8-3.7-2.4-4.5-4.5l-28.8-72.9l-72.9-28.8c-4.1-1.6-6.1-6.3-4.5-10.4c0.8-2.1,2.4-3.7,4.5-4.5 l72.9-28.8l28.8-72.9c1.6-4.1,6.3-6.1,10.4-4.5c2.1,0.8,3.7,2.4,4.5,4.5L228.2,155.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpVideoActive);
export default __webpack_public_path__ + "static/media/hp_video_active.f578cc2e197e3e5aab4dbbe754c8095b.svg";
export { ForwardRef as ReactComponent };